<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="pharmacies"
      :single-expand="true"
      :expanded.sync="expanded"
      item-key="id"
      sort-by="name"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Pharmacies</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on"
                >New Item</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form v-model="valid">
                    <v-text-field
                      v-model="editedItem.name"
                      label="Pharmacy name"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.address"
                      label="Address"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.email"
                      :rules="emailRules"
                      label="Email"
                    ></v-text-field>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="activationDialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Activate this pharmacy</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">{{
                        activationItem.name
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        activationItem.address
                      }}</v-list-item-title>
                      <v-list-item-subtitle
                        class="font-italic font-weight-light"
                        >address</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        activationItem.email
                      }}</v-list-item-title>
                      <v-list-item-subtitle
                        class="font-italic font-weight-light"
                        >email</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn
                  color="blue darken-1"
                  outlined
                  @click="sendActivationRequest"
                >
                  <v-icon small class="mr-2">mdi-email</v-icon>
                  Send activation Email
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="activate(item)">
          mdi-rocket
        </v-icon>
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">More info about {{ item.name }}</td>
      </template>
      <!-- <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template> -->
    </v-data-table>
    <template>
      <div class="text-center ma-2">
        <v-snackbar v-model="showEmailRequiredSnackbar">
          Email address is required for activation.
          <v-btn color="accent" text @click="showEmailRequiredSnackbar = false">
            Close
          </v-btn>
        </v-snackbar>
      </div>
    </template>
  </v-container>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("loadPharmacies");
  },
  computed: {
    pharmacies() {
      return this.$store.getters.getPharmacies;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },
  data() {
    return {
      expanded: [],
      dialog: false,
      valid: true,
      activationDialog: false,
      showEmailRequiredSnackbar: false,
      loading: true,
      headers: [
        { text: "Pharmacy Name", value: "name" },
        { text: "Address", value: "address" },
        { text: "Email", value: "email" },
        { text: "Actions", value: "actions", sortable: false }
      ],

      editedIndex: -1,
      editedItem: {
        name: "",
        address: "",
        email: ""
      },

      // todo: we don't need this
      defaultItem: {
        name: "",
        address: "",
        email: ""
      },

      activationItem: {
        name: "",
        address: "",
        email: ""
      },

      emailRules: [
        v => {
          return !v || /.+@.+/.test(v) || "E-mail must be valid";
        }
      ]
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.pharmacies.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$store.dispatch("deletePharmacy", item);
      }
    },

    activate(item) {
      if (!item.email) {
        this.showEmailRequiredSnackbar = true;
      } else {
        this.activationItem = item;
        this.activationDialog = true;
      }
    },

    sendActivationRequest() {
      console.log("sendActivationRequest:");
      console.log(this.activationItem);
      if (!this.activationItem.email) {
        this.showEmailRequiredSnackbar = true;
      } else {
        this.$store.dispatch("activatePharmacy", this.activationItem);
      }
      this.close();
    },

    close() {
      this.dialog = false;
      this.activationDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (!this.valid) {
        return;
      }
      if (this.editedIndex > -1) {
        this.$store.dispatch("updatePharmacy", this.editedItem);
      } else {
        // todo new item
        this.pharmacies.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>
